export const ACCENT_BUTTON =
  'cursor-pointer bg-green-main text-white active:bg-green-light sm:hover:bg-green-light';
export const ACCENT_BUTTON_RED =
  'cursor-pointer bg-red-main text-white active:bg-red-light sm:hover:bg-red-light';

export const ACCENT_BUTTON_DISABLED =
  'cursor-default bg-gray-light text-gray-dark pointer-events-none';
export const ACCENT_BUTTON_RED_DISABLED = ACCENT_BUTTON_DISABLED;

export default {
  default: ACCENT_BUTTON,
  red: ACCENT_BUTTON_RED,
  'default-disabled': ACCENT_BUTTON_DISABLED,
  'red-disabled': ACCENT_BUTTON_RED_DISABLED,
};
